import Head from 'next/head';
import React from 'react';

export const PreconnectLinks: React.FC<{ preconnectLinks: string[] }> = ({
  preconnectLinks,
}) => {
  if (preconnectLinks.length === 0) return null;

  return (
    <Head>
      {preconnectLinks.map((link: string) => (
        <React.Fragment key={link}>
          <link rel="preconnect" href={link} />
          <link rel="dns-prefetch" href={link} />
        </React.Fragment>
      ))}
    </Head>
  );
};
